import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Quote from "@public/subdomain/why-use-lumi/landing/quote.png";
import Star from "@public/subdomain/why-use-lumi/landing/star.png";
import Hyril from "@public/subdomain/why-use-lumi/landing/user-review/hyril.jpeg";
import Maxine from "@public/subdomain/why-use-lumi/landing/user-review/Maxine Desiree.png";
import Waikit from "@public/subdomain/why-use-lumi/landing/user-review/waikit.jpeg";
import Image from "next/image";
import { useRouter } from "next/router";
import WhyUseLumiCarousel from "./why-use-lumi-carousel";

const ReviewCarousel: React.FunctionComponent = () => {
  const { locale } = useRouter();
  const reviews =
    locale === "ms"
      ? [
          {
            text: "Lumi News Malaysia terbaik dan padat dengan berita-berita terkini dalam dan luar negara. Memang best. Saya bagi 5 bintang.",
            name: "Japris Budau",
          },
          {
            text: "Aplikasi yang amat mudah untuk digunakan. Tiada iklan dan senang untuk mendapatkan info terkini.",
            name: "Hyril Hamdan",
            image: Hyril,
          },
          {
            text: "apps yang berguna untuk mengetahui info terkini dan sahih 😍 terbaik!!!",
            name: "Syaa",
          },
          {
            text: "Aplikasi bagus berfungsi dengan sempurna",
            name: "Kamal",
          },
          {
            text: "Berita yang mudah faham,terkini dan tepat",
            name: "Faiq Muhammad",
          },
        ]
      : [
          {
            text: "Fast and reliable news. The notifications are very useful.",
            name: "Razif Ismail",
          },
          {
            text: "Beautiful and clean UI. Easier to read and favorable collection of news in one app.",
            name: "Benedict W S",
          },
          {
            text: "Every Malaysian should have this app!",
            name: "Sin Wai Kit",
            image: Waikit,
          },
          {
            text: "Love how the app lets me customise my news feed to my interests!",
            name: "Puteri Abd",
          },
          {
            text: "Love how clean, neat and user friendly the app is. So much easier to read and share the news. Even my parents downloaded it!",
            name: "Maxine Desiree",
            image: Maxine,
          },
        ];

  return (
    <div className="mb-16 bg-white px-6 md:mb-40">
      <div className="mx-auto max-w-7xl">
        <WhyUseLumiCarousel
          children={reviews.map((review, index) => (
            <div
              className="relative mx-auto px-6 pt-16 pb-48 md:pb-60"
              key={index}
            >
              <div className="absolute top-28">
                <Image src={Quote} alt="quote" width={92} height={72} />
              </div>
              <div className="flex flex-col items-start px-3 md:items-center">
                <div className="flex">
                  {[...Array(5)].map((_, index) => (
                    <div className="mr-1" key={index}>
                      <Image src={Star} alt="Star" height={40} width={40} />
                    </div>
                  ))}
                </div>
                <p className="relative mt-6 text-left font-poppins text-xl text-text-darkest md:text-center">
                  {review["text"]}
                </p>

                <div className="mt-6 flex justify-center">
                  {review["image"] && (
                    <div className="mr-4">
                      <Image
                        src={review["image"]}
                        width={32}
                        height={32}
                        className="rounded-full"
                        alt="user-photo"
                      />
                    </div>
                  )}
                  <span className="font-poppins text-xl font-bold text-text-dark">
                    {review["name"]}
                  </span>
                </div>
              </div>
            </div>
          ))}
          arrowTopPosition="80%"
        />
      </div>
    </div>
  );
};

export default ReviewCarousel;
